import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DetailCard from '../components/DetailCard';
import DetailHeader from '../components/DetailHeader';
import InfoList from '../components/InfoList';
import LoadStatus from '../components/LoadStatus';
import { getContact } from './contactApi';

const BACK = { backTo: '/admin/contacts', backLabel: '기업 문의 목록' };

// 기업 문의 상세 화면. 회사·담당자 연락처와 문의 내용을 보여준다. 이메일·전화는 바로 걸 수 있게 링크로 둔다.
export default function ContactDetailPage() {
    const { contactId } = useParams();
    const [item, setItem] = useState(null);
    const [error, setError] = useState('');

    // 기업 문의 상세를 불러온다.
    const load = useCallback(async () => {
        setError('');
        setItem(null);
        try {
            setItem(await getContact(contactId));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [contactId]);

    useEffect(() => { load(); }, [load]);

    if (!item) return <><DetailHeader {...BACK} title="기업 문의" /><LoadStatus error={error} onRetry={load} /></>;

    return (
        <>
            <DetailHeader {...BACK} title={`${item.company || '기업'} 문의`} />
            <DetailCard title="문의자 정보">
                <InfoList items={[
                    { label: '지역/회사명', value: item.company },
                    { label: '담당자', value: item.manager_name },
                    { label: '이메일', value: item.email && <a href={`mailto:${item.email}`}>{item.email}</a> },
                    { label: '연락처', value: item.phone && <a href={`tel:${String(item.phone).replace(/[^0-9+]/g, '')}`}>{item.phone}</a> },
                    { label: '접수일', value: item.created_at },
                    { label: '개인정보 수집 동의', value: item.privacy_agreed ? '동의' : '미동의' },
                ]} />
            </DetailCard>
            <DetailCard title="문의 내용"><p>{item.content}</p></DetailCard>
        </>
    );
}
